/* eslint-disable */

import { type SVGProps } from "react";
import { cn } from "../../lib/utils";

export function YouTube({
  className,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={cn("w-[1em] h-[1em]", className)}
      viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      
<g clipPath="url(#clip0_863_509)">
<path d="M15.0269 4.89485C14.8582 4.28017 14.3613 3.79614 13.7302 3.63186C12.5865 3.33331 8.00008 3.33331 8.00008 3.33331C8.00008 3.33331 3.41369 3.33331 2.26991 3.63186C1.63888 3.79614 1.14188 4.28017 0.973226 4.89485C0.666748 6.0089 0.666748 8.33331 0.666748 8.33331C0.666748 8.33331 0.666748 10.6577 0.973226 11.7719C1.14188 12.3865 1.63888 12.8705 2.26991 13.0348C3.41369 13.3333 8.00008 13.3333 8.00008 13.3333C8.00008 13.3333 12.5865 13.3333 13.7302 13.0348C14.3613 12.8705 14.8582 12.3865 15.0269 11.7719C15.3334 10.6577 15.3334 8.33331 15.3334 8.33331C15.3334 8.33331 15.3334 6.0089 15.0269 4.89485Z" fill="#FF0302"></path>
<path d="M6.5 10.4437L10.3333 8.33338L6.5 6.2229V10.4437Z" fill="white"></path>
</g>
<defs>
<clipPath id="clip0_863_509">
<rect width="14.6667" height="10" fill="white" transform="translate(0.666748 3.33331)"></rect>
</clipPath>
</defs>

    </svg>
  );
}
